/**
 * Constantes compartidas de Zicasso.
 * STAGES: mapea sales_stage -> etiqueta/colores. Compartido entre el Dashboard y
 * el modal del lead (extraído aquí para evitar un import circular entre ambos).
 */
export const STAGES = [
  { key: "", label: "Nuevo", bg: "#E2EBE5", text: "#244532" },
  { key: "FIRST_MESSAGE_SENT", label: "1er mensaje", bg: "#F1E9DA", text: "#6B4F20" },
  { key: "CONSULTATION", label: "Consultation", bg: "#E5E8F2", text: "#34406B" },
  { key: "ITINERARY_IN_REVIEW", label: "Itinerario en revisión", bg: "#F4E3DD", text: "#803D26" },
  { key: "ITINERARY_SENT", label: "Itinerario enviado", bg: "#E0EBEB", text: "#235858" },
  { key: "PROPOSAL_SENT", label: "Propuesta enviada", bg: "#E8E2F0", text: "#4F3675" },
];
